// removed by extract-text-webpack-plugin
module.exports = {"Terms":"Terms__Terms__2otUX","Block":"Terms__Block__yQWCh"};


//////////////////
// WEBPACK FOOTER
// ./client/src/containers/Terms/Terms.css
// module id = 430
// module chunks = 0